import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { handleGroupSuggestionClick } from 'actions/signupForm/addOrEdit'
import { xor } from 'lodash'
import language from 'utils/vast-languagepack'
import GroupDialog from 'components/GroupDialog'
import { toggleGroupDialog } from 'actions/contacts/groups'

export default connect(
	(state) => ({
		groupSelectValue: state.signupForm.addOrEdit.groupSelect.value,
		groupsByID: state.contacts.groupsByID,
	}),
	(dispatch) =>
		bindActionCreators(
			{ handleGroupSuggestionClick, toggleGroupDialog },
			dispatch,
		),
)(
	withStyles(styles)(
		({
			classes,
			handleGroupSuggestionClick,
			groupsByID,
			groupSelectValue,
			toggleGroupDialog,
		}) => {
			const value = xor(
				Object.keys(groupsByID),
				groupSelectValue.map((group) => group.groupID),
			)
				.map((id) => groupsByID[id])
				.sort((a, b) => {
					if (a.contact_count < b.contact_count) return 1
					if (a.contact_count > b.contact_count) return -1
					return 0
				})
				.slice(0, 3)

			return (
				<>
					<Typography variant="caption" gutterBottom>
						<strong>{language.general.shared.suggestions}</strong>{' '}
						<span>
							<button
								type="button"
								className={classes.linkButton}
								onClick={() => toggleGroupDialog()}
							>
								Create group
							</button>
						</span>
						{', '}
						{value.map((group, idx) =>
							group ? (
								<span key={`${group.name}Suggestion`}>
									<button
										type="button"
										className={classes.linkButton}
										onClick={() =>
											handleGroupSuggestionClick({
												groupID: group.id,
												value: group.id,
												label: `${group.name}`,
												key: `${group.id}GroupSelectValue`,
											})
										}
									>
										{group.name}
									</button>
									{idx === value.length - 1 ? null : ', '}
								</span>
							) : null,
						)}
					</Typography>
					<GroupDialog
						thenFunc={(payload) => {
							handleGroupSuggestionClick({
								groupID: payload.id,
								value: payload.id,
								label: `${payload.name}`,
								key: `${payload.id}GroupSelectValue`,
							})
						}}
					/>
				</>
			)
		},
	),
)
